import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "105%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i, ease } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block" variants={line} custom={delay + i * 0.12}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const SectionHead = ({ eyebrow, title, intro, id }) => (
  <div className="grid gap-8 lg:grid-cols-12">
    <div className="lg:col-span-4">
      <Reveal><p className="eyebrow" data-testid={`${id}-eyebrow`}>{eyebrow}</p></Reveal>
    </div>
    <div className="lg:col-span-8">
      <h2 className="font-serif-d text-4xl leading-[1.02] tracking-tight text-[var(--ink)] sm:text-5xl lg:text-6xl">
        <MaskLines lines={title} inView />
      </h2>
      {intro && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[var(--ink-2)] md:text-lg">{intro}</p>
        </Reveal>
      )}
    </div>
  </div>
);
